import { Portal } from '@color/continuum';
import { useRouteMatch } from 'react-router-dom';

import { Announcements } from 'lib/util/notificationService';
import { RequireAuth } from 'ui/Auth';
import { CulDeSac } from 'ui/Auth/CulDeSac';
import { CareParticipantAppBar } from 'ui/common/components/ClientNav/CareParticipantAppBar';

import { PATIENT_MESSAGING_INBOX_PATH } from './paths';
import { Routes } from './Routes';

export const PatientMessagingPortal: React.FC = () => {
  const isInboxPath = Boolean(useRouteMatch({ path: PATIENT_MESSAGING_INBOX_PATH, exact: true }));

  return (
    <>
      <Portal
        navBarComponent={<CareParticipantAppBar />}
        announcementsContainerComponent={<Announcements />}
        contentMinHeight="auto"
        showFooter={isInboxPath}
      >
        <RequireAuth>
          <CulDeSac>
            <Routes />
          </CulDeSac>
        </RequireAuth>
      </Portal>
    </>
  );
};
